<template>
  <div class="diseaseList">
    <!-- 筛选查询框 -->
    <el-form :inline="true" size="small">
      <el-form-item label="客户分类">
        <el-select
          v-model="selectuserType"
          placeholder="请选择"
          @change="select_userType"
          clearable
        >
          <el-option
            v-for="(item, index) in userTypeArr"
            :label="item"
            :value="item"
            :key="index"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          clearable
          v-model="inputName"
          placeholder="请输入(姓名和号码)"
          style="margin-left: 10px; width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item style="margin-left: 10px">
        <el-button type="primary" @click="selectgoodsbynameBtn" v-waves
          >搜索</el-button
        >
      </el-form-item>
      <!-- <el-form-item>
      <el-input
        v-model="fairstr"
        placeholder="请输入公司名(精确的)"
        style="margin-left: 50px; width: 200px"
      ></el-input>
    </el-form-item>
    <el-form-item style="margin-left: 30px">
      <el-button type="primary" @click="selectfairstrBtn">搜索</el-button>
    </el-form-item>-->

      <!--<el-form-item label="二级分类">
      <el-select v-model="select_two_id" placeholder="请选择">
        <template v-for="item in nextCategoryArr">
          <el-option :label="item.categoryName" :value="item.id" :key="item.id"></el-option>
</template>
        </el-select>
      </el-form-item>-->
      <!-- <el-form-item>
        <el-button type="primary" @click="selectGoodsBtn">查询</el-button>
      </el-form-item>-->
      <el-form-item style="margin-left: 10px">
        <el-button type="primary" @click="ejectaddGoods" v-waves
          >新增数据</el-button
        >
      </el-form-item>

      <el-form-item style="margin-left: 10px">
        <el-button
          :loading="downloadLoading"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          v-waves
          >导出 Excel（数量/ {{ tableData.length }}条）</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button type="danger" v-waves>总数{{ listQuery.total }}</el-button>
      </el-form-item>
    </el-form>

    <div class="tableList">
      <!-- 封装表单table组件 -->
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button size="mini" type="text" @click="kelongGoods(row)">
              克隆</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="ejectupdataGoods(row)"
              >详情(编辑)</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="deleteGoods(row)"
              style="color: rgb(255, 0, 0);"
              >删除</el-button
            >
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 产品提交表单 -->
    <el-dialog
      :title="inputTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form">
        <el-form-item label="客户分类" :label-width="formLabelWidth" required>
          <el-select
            v-model="form.userType"
            placeholder="请选择客户类型"
            @change="sumbmituserType"
          >
            <el-option
              v-for="(item, index) in userTypeArr"
              :label="item"
              :value="item"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="公司名称" :label-width="formLabelWidth" required>
          <el-input
            v-model="form.fairTitle"
            auto-complete="off"
            @blur="fairTitleblur"
          ></el-input>
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth" required>
          <el-input v-model="form.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth" required>
          <el-input v-model="form.phone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="职务" :label-width="formLabelWidth">
          <el-input v-model="form.job" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="form.email" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" :label-width="formLabelWidth">
          <el-input v-model="form.adress" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户描述" :label-width="formLabelWidth">
          <el-input v-model="form.userDescribe" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="updataBtn" :disabled="!btn"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  add_p,
  updata_p,
  delete_p,
  select_p,
} from "@/services/supAdmin/foodExpo.js";
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
export default {
  components: {
    ElTable,
  },
  created() {
    this.select();
  },
  data() {
    return {
      // 筛选查询条件
      selectForm: {
        pageSize: 1,
        pageNumber: 10,
      },
      // 数据总数
      listQuery: {},
      downloadLoading: false,
      tableData: [],
      userTypeArr: [
        // "全部",
        "预制食材",
        "生鲜食材",
        "速冻食材",
        "方便菜",
        "自热食品",
        "即食食品",
        "复合调味料",
        "冷链物流",
        "食品加工包装",
        "机械配套耗材",
        "中央厨房设备",
        "新零售业态",
        "行业协会",
        "主管部门",
        "观众",
        "其他",
      ],
      userType: "",
      selectuserType: "",
      // 一级分类 二级分类 商品
      select_one_id: "",
      select_two_id: "",
      categoryArr: [
        { id: 1, name: "A" },
        { id: 2, name: "B" },
      ],
      nextCategoryArr: [],
      formLabelWidth: "120px",
      action: "http://houtainongte.shanghaibojun.cn/miniLoveTeaImg",
      fileList: [],
      loading: true,
      pageCount: "",
      pageSize: 8,
      form: {},
      dialogFormVisible: false,
      inputTypeName: "",
      // 表单搜索
      inputName: "",
      fairstr: "",
      // 是否显示分页
      pagination: 1,
      btn: true,
    };
  },

  computed: {
    listHeader,
  },
  methods: {
    init() {
      this.$message({
        type: "success",
        message: "查询成功!",
      });
    },
    info() {
      this.$message({
        type: "info",
        message: "失败",
      });
    },
    // 查询数据
    select() {
      this.loading = true;
      select_p(this.selectForm).then((resp) => {
        console.log(resp);
        this.tableData = resp.data.rows;
        this.listQuery.total = resp.data.total;
        setTimeout(() => {
          this.loading = false;
        }, 500);

        // this.init();
      });
    },

    // 客户分类查询
    select_userType(e) {
      this.loading = true;
      console.log(e);
      this.selectForm.userType = e;
      this.selectForm.pageSize = 1;
      this.select();
    },

    // 根据关键字搜索
    selectgoodsbynameBtn() {
      this.loading = true;
      let name = this.inputName;
      console.log(name);
      this.selectForm.name = name;
      this.selectForm.pageSize = 1;
      this.select();
    },
    // 公司名去重提醒
    fairTitleblur() {
      console.log(this.form.fairTitle);
      if (this.form.fairTitle == "" || this.form.fairTitle == undefined) {
        // Toast("公司名不能为空");
        this.$message.error("公司名不能为空");
      }
      // else {
      //   select_fairstr(this.form.fairTitle).then((res) => {
      //     console.log(res);
      //     if (res.data.length > 0) {
      //       this.$message({
      //         type: "info",
      //         message: "注意该公司名已经被录入",
      //       });
      //     }
      //   });
      // }
    },

    sumbmituserType(e) {
      console.log(e);
    },
    ejectaddGoods() {
      this.dialogFormVisible = true;
      this.inputTypeName = "新增数据";
      this.form = {};
    },
    ejectupdataGoods(row) {
      console.log(row);
      this.dialogFormVisible = true;
      this.inputTypeName = "修改数据详情";
      this.form = row;
    },
    // 克隆数据
    kelongGoods(row) {
      console.log(row);
      var formData = {
        adress: row.adress,
        email: row.email,
        fairTitle: row.fairTitle,
        job: row.job,
        name: row.name,
        phone: row.phone,
        userDescribe: row.userDescribe,
        userType: row.userType,
      };
      add_p(formData).then((resp) => {
        console.log(resp);
        if (resp.code == 200) {
          this.dialogFormVisible = false;
          this.selectForm.name = "";
          this.selectForm.pageSize = 1;
          this.select();
        } else {
          this.info();
        }
      });
    },
    // 提交表单按钮
    updataBtn() {
      this.btn = false;
      setTimeout(() => {
        this.btn = true;
      }, 2000); //按钮禁用2秒安全防护

      console.log("点击了确认");
      let formData = this.form;
      if (formData.userType == undefined) {
        this.$message({
          type: "info",
          message: "请选择客户分类",
        });
        return;
      }
      // 非空判断
      if (
        formData.name == undefined ||
        formData.name == "" ||
        formData.phone == undefined ||
        formData.phone == "" ||
        formData.fairTitle == undefined ||
        formData.fairTitle == ""
      ) {
        this.$message({
          type: "info",
          message: "姓名，手机号，公司名，客户分类 为必填选项",
        });
        return;
      }

      if (this.inputTypeName == "新增数据") {
        console.log("新增数据-----------", formData.name);

        add_p(formData).then((resp) => {
          console.log(resp);
          if (resp.code == 200) {
            this.init();
            this.dialogFormVisible = false;
            this.select();
          } else {
            this.info();
          }
        });
      }

      if (this.inputTypeName == "修改数据详情") {
        console.log("修改数据详情------------");
        updata_p(formData).then((resp) => {
          console.log(resp);
          if (resp.code == 200) {
            this.dialogFormVisible = false;
            this.select();
          } else {
            this.info();
          }
        });
      }
    },
    // 删除数据
    deleteGoods(row) {
      console.log(row.id);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delete_p({id:row.id}).then((resp) => {
            console.log(resp);
        if(resp.code===200){
              this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.select();
        }else{
                  this.$message({
              type: "error",
              message: "删除失败!",
            });
        }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 切换每页数量
    handleSizeChange(e) {
      console.log(e);
      this.selectForm.pageNumber = e;
      this.selectForm.pageSize = 1;
      this.select();
    },
    // 分页页码
    handleCurrentChange(e) {
      console.log(e);
      this.selectForm.pageSize = e;
      this.select();
    },

     // 导出数据
     handleDownload() {
      this.downloadLoading = true;
      import("@/utils/vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "时间",
          "用户类型",
          "公司名",
          "姓名",
          "职务",
          "手机号",
          "邮箱",
          "地址",
          "用户备注",
        ];
        const filterVal = [
          "createTime",
          "userType",
          "fairTitle",
          "name",
          "job",
          "phone",
          "email",
          "adress",
          "userDescribe",
        ];
        const list = this.tableData;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "博峻食品展数据库",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      console.log("jsonData",jsonData)
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
  },
};
</script>

<style scoped>
.diseaseList {
  width: 100%;
}
</style>
